export default __webpack_public_path__ + "static/media/ru-lpr.1e17ae48.svg";